import { StatusBadgeController } from './status-badge.controller'

function statusBadgeDirective () {
  return {
    restrict: 'E',
    scope: {
      status: '<'
    },
    templateUrl: '/workflow/directives/status-badge/status-badge-directive.html?$$REVISION$$',
    controller: StatusBadgeController
  }
}

export { statusBadgeDirective }
